module.exports = __webpack_public_path__ + "img/half_triggered.b7241ea2.svg";